import httpManager from "@/app/shared/utils/httpManager";
import { ReportTypes } from "@/app/reports/utils/enums";

export async function downloadInboundVoiceReport({ filters } = {}) {
  let query = "";
  query += `portfolio=${filters.portfolio}&`;
  if (filters.base) query += `base=${filters.base}&`;
  query += `start_date=${filters.startDate}&`;
  query += `end_date=${filters.endDate}`;

  const url = `/reports/${ReportTypes.InboundVoice}/download/?${query}`;

  const response = await httpManager.post(url, {}, { blob: true });
  return response;
}
